module.exports = __webpack_public_path__ + "static/media/gestor.346aa62b.png";